<template>
  <div class="container-article">
    <div
      v-for="attribute in errors"
      :key="attribute.field"
      class="alert alert-danger"
    >
      {{ attribute.value }}
    </div>
    <h4 class="m-3">Изменение статьи</h4>
    <el-form ref="form" label-position="left" label-width="220px">
      <el-form-item label="Название">
        <el-input v-model="form.title"></el-input>
      </el-form-item>
      <el-form-item label="Подзагаловок">
        <el-input v-model="form.subTitle"></el-input>
      </el-form-item>
      <el-alert type="info" show-icon :closable="false">
        <p>
          Загрузите изображение чтобы получить ссылку, полученную ссылку можете
          добавить в текстовое поле
        </p>
      </el-alert>
      <el-form-item label="Изображение">
        <el-upload
          action="#"          
          ref="uploadRef"
          list-type="picture"
          v-model="form.image"
          :http-request="handleImageRequest"
        >
          <template #file="{ file }">
            <img :src="file.url" class="el-upload-list__item-thumbnail" />
            <el-row>
              <el-col>
                {{ file.name }}
              </el-col>
              <el-col v-if="file.response">
                Ссылка: {{ file.response }}
              </el-col>
            </el-row>
            <label class="el-upload-list__item-status-label"
              ><i class="el-icon-upload-success el-icon-check"></i
            ></label>
            <i
              class="el-icon-close"
              v-if="file.status === 'success'"
              @click="handleRemoveImage(file)"
            ></i>
          </template>
          <el-button size="small" type="primary"
            >Добавить Изображение</el-button
          >
        </el-upload>
      </el-form-item>
      <el-alert type="info" show-icon :closable="false">
        <p>
          Изображение для краткого описания блогов
        </p>
      </el-alert>
      <el-form-item label="Изображение для списка">
        <el-upload
        action=""
        list-type="picture"
        :file-list="fileList"
        :limit="1"
        :auto-upload="false"        
        :on-change="handleChange"
        >
          <el-button size="small" type="primary">Добавить Изображение</el-button>
        </el-upload>
      </el-form-item>
      <el-form-item label="Текст перед видео">
        <ckeditor v-model="form.content.topText" />
      </el-form-item>
      <el-form-item label="Ссылка на видео">
        <el-input v-model="form.content.video.src"></el-input>
      </el-form-item>
      <el-form-item label="Подпись под видео">
        <el-input v-model="form.content.video.capture"></el-input>
      </el-form-item>
      <el-form-item label="Текст после видео">
        <ckeditor v-model="form.content.bottomText" />
      </el-form-item>
      <el-form-item label="Категория статей">
        <el-select
          v-model="form.articleSectionId"
          filterable
          clearable
          placeholder="Выберите категорию"
          no-data-text="Нет данных"
        >
          <el-option
            v-for="item in categories"
            :key="item.id"
            :label="item.title"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="Сортировка">
        <el-input type="number" v-model="form.sort"></el-input>
      </el-form-item>
      <el-form-item label="Активность">
        <el-checkbox v-model="form.activity"></el-checkbox>
      </el-form-item>
      <el-form-item label="Тэги">
        <el-row>
          <el-col :span="12" class="article-tag">
            <el-select
              v-model="form.tags"
              clearable
              multiple
              placeholder="Выберите тег"
              class="container-article__select"
            >
              <el-option
                v-for="item in tags"
                :key="item.id"
                :label="item.title"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-col>
          <el-col :span="2">
            <el-button
              type="primary"
              @click="$store.commit('articleTagCreateDialog', true)"
            >
              Добавить тэг
            </el-button>
          </el-col>
        </el-row>
      </el-form-item>
      <el-form-item label="Тип статьи">
        <el-radio
          v-for="(item, index) in getTypeArticles"
          :key="index"
          v-model="form.type"
          :label="item.value"
        >
          {{ item.title }}
        </el-radio>
      </el-form-item>
      <el-form-item
        v-if="form.type === articleType.section.value"
        label="Раздел каталога"
      >
        <el-select
          v-model="form.catalogSectionId"
          clearable
          filterable
          placeholder="Выберите раздел"
          no-data-text="Нет данных"
        >
          <el-option
            v-for="item in getSections"
            :key="item.id"
            :label="item.title"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item
        v-if="form.type === articleType.product.value"
        label="Товары, относящиеся к статье"
      >
        <el-button
          type="primary"
          size="small"
          @click="$store.commit('showProductsDialog', true)"
        >
          Выбрать товары
        </el-button>
        <el-tag checked>Выбрано: {{ form.products.length }}</el-tag>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="onStoreFormData">Изменить</el-button>
        <el-button @click="back()">Отмена</el-button>
      </el-form-item>
    </el-form>
    <create-article-tag-dialog @changeTag="onAddTag" />
    <select-products
      :selectedProducts="form.products"
      @select-product="(e) => selectProduct(e)"
      v-if="$store.getters.showProductsDialog"
    ></select-products>
  </div>
</template>

<script>
import axios from "axios";
import CreateArticleTagDialog from "@/components/Articles/createArticleTagDialog";
import SelectProducts from "@/components/Products/SelectProducts";
import articleType from "@/composable/type/article.type";
import useFormData from "../../composable/useFormData";
import getErrors from '../../composable/utils/getErrors';
import getFileList from '../../composable/utils/getFileList'
import { SETPRELOADER_STATE } from "@/store/mutation-types";

export default {
  name: "BannerCreate",
  components: {
    SelectProducts,
    CreateArticleTagDialog,
  },
  data: function () {
    return {
      articleType,
      form: {
        title: "",
        subTitle: "",
        articleSectionId: '',
        catalogSectionId: '',
        products: [],
        tags: [],
        type: articleType.article.value,
        content:{
          topText: '',
          bottomText: '',
          video: {
            src: '',
            capture: ''
          },
          image: ''
        },
        sort: 0,
        activity: false,
        required: false,
      },
      errors: [],
      sections: [],
      fileList: [],
      tags: [],
      status: 0,
      categories: [],
      dialogVisible: false,
      arrResultForm: [],
      selectedProductCounter: null,      
    };
  },
  mounted() {
    this.categories = this.$store.getters.categories;
    this.tags = this.$store.getters.tags;

    this.$store.commit(SETPRELOADER_STATE, true);

    this.getData()
    .then((response) => {
      const [article, categories, tags, products] = response;

      this.setFileList(article.data?.content?.img || []);
      this.setForm(article.data);

      this.categories = categories.data.data;
      this.tags = tags.data;
      this.form.products = products.data
    })
    .catch()
    .finally(() => this.$store.commit(SETPRELOADER_STATE, false));
  },
  computed: {
    getTypeArticles() {
      const values = Object.values(this.articleType);
      if (values && values.length > 0) {
        return values;
      }
      return [];
    },
  },
  methods: {
    selectProduct(productSelectCounter) {
      this.selectedProductCounter = productSelectCounter;
    },
    getData() {
      return Promise.all([
        axios.get("/blog/article/" + this.$route.params.id),
        axios.get("blog/section"),
        axios.get("blog/tag"),
        axios.get(`/blog/article/${this.$route.params.id}/product`)
      ]);
    },
    removeOption(e) {
      this.form.tags = this.form.tags.filter((el) => el.id !== e.id);
    },
    selectOption(e) {
      this.form.tags.push(e);
    },
    back() {
      this.$router.push("/articles");
    },
    setProducts(value) {
      if (value && value.length > 0) {
        this.products = value;
      } else {
        this.products = [];
      }
      this.form.products = this.products.map((e) => e.id);
    },
    getFieldsByTypeArticle(type) {
      const fields = Object.keys(this.form);
      let findResult = -1;

      if (type === this.articleType.section.value) {
        findResult = fields.findIndex((e) => e === 'products');        
      }

      if (type === this.articleType.product.value) {
        findResult = fields.findIndex((e) => e === 'catalogSectionId');
      }

      if(findResult >= 0) {
        fields.splice(findResult, 1)
      }

      if (type === this.articleType.article.value) {
        findResult = fields.findIndex((e) => e === 'products');
        
        if(findResult >= 0) {
          fields.splice(findResult, 1)
        }

        findResult = fields.findIndex((e) => e === 'catalogSectionId');
        
        if(findResult >= 0) {
          fields.splice(findResult, 1)
        }
      }
      return fields;
    },
    async  handleImageRequest(v) {
      this.form.image = v.file;
      let linkResult = '';
      const _formData = new FormData();  
      _formData.append('image', v.file);
      try {
        const response = await axios.post('image', _formData)
        linkResult = response.data.path ?? '';
      } catch(e) {
        // TODO
      }

      return linkResult;
    },
    handleRemoveImage(v) {
      if (this.$refs.uploadRef && v) {
        this.$refs.uploadRef.handleRemove(v.raw);
      }
    },
    handleChange(v){
      this.form.content.image = v?.raw || undefined
    },
    toggleDialog() {
      this.dialogVisible = !this.dialogVisible;
    },
    onAddTag(v) {
      if (v) {        
        this.tags.push(v);
      }
    },
    onUpdateProducts(value) {
      this.setProducts(value);
    },
    onStoreFormData() {
      this.form.products = [...this.form.products.map((item) => item.id)]
      
      const { execute } = useFormData();
      const fields = this.getFieldsByTypeArticle(this.form.type);

      this.arrResultForm = execute().setFields(fields).getFormData(this.form);



      axios.post(`blog/article/${this.$route.params.id}`, this.arrResultForm)
      .then(() => {
        this.back()
      })
      .catch((errors) => {
        if(errors.response.status === 422) {
          this.setErrors(errors.response.data.errors)
        }
      });
    },
    setErrors(err) {
      this.errors  = getErrors(err)
    },
    setTags(tags) {
      if (tags?.length && tags.length > 0) {
        this.form.tags = tags.map((e) => e.id);
      } else {
        this.form.tags = [];
      }
    },
    setFileList(value){
      this.fileList = getFileList(value)
    },
    setForm(value) {
      if(value) {
        this.form.title = value.title || '';
        this.form.subTitle = value.sub_title || '';
        this.form.articleSectionId = value.category?.id || '';
        this.form.catalogSectionId = value.catalog_section_id || '';
        this.form.products = value.products || [];
        this.form.type = value.type || articleType.article.value;
        this.form.sort = value.sort || 0;
        this.form.activity = value.activity || false;
        this.form.required = value.required || false;
        this.form.content.topText = value.content?.top_text || '';
        this.form.content.bottomText = value.content?.bottom_text || '';        
        this.form.content.video.src = value.content?.video?.src || '';
        this.form.content.video.capture = value.content?.video?.capture || '';
        this.form.tags = value.tags || [];
        this.setTags(value.tags);
      }
    }
  },
};
</script>

<style>
.container-article .container-article__select{
  width: auto;
}

.el-row .article-tag {
  width: auto;
  margin-right: 40px;
}
</style>
